<template>
<div class="chapter">
<div class="inner_page">
<a id="page_v"></a>
<p class="fm04"><em class="italic">Je ne puis pas regarder une feuille darbre</em></p>
<p class="fm02"><em class="italic">sans être écrasé par l’univers.</em></p>
<p class="fm02">I cannot look at a leaf on a tree</p>
<p class="fm02">without being bowled over by the universe.</p>
<p class="fm02t">Victor Hugo</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 03_Fm02.vue?e9806400